import { GridToolbarColumnsButton, Toolbar } from '@mui/x-data-grid-pro';
import { ThemeProvider } from '@mui/material/styles';
import { customToolbarButtonTheme } from 'assets/styles/themes/generic_button_mui';
import { Button as MButton } from '@mui/material';
import { IMPORT_FROM } from 'utils/GlobalVariables';
import ImportButtonListAndModal from 'components/pages/Cooperative/ImportButtonListAndModal';
import { useTranslation } from 'react-i18next';

type CustomToolbarProcedureParams = {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  typeProcedure: string;
  mappingFiles: string[] | null;
  nextForecastCampaign: string;
};

export const CustomToolbarProcedure = ({
  setModal,
  typeProcedure,
  mappingFiles,
  nextForecastCampaign,
}: CustomToolbarProcedureParams) => {
  const { t } = useTranslation();
  return (
    <Toolbar>
      <GridToolbarColumnsButton
        slotProps={{
          button: { style: { color: '#277134' } },
        }}
      />
      <div className="d-flex justify-space-between">
        {mappingFiles !== null && (
          <ImportButtonListAndModal
            locationRoute={'exploitation'}
            from={IMPORT_FROM.procedure}
            mappingFiles={mappingFiles}
            nextForecastCampaign={nextForecastCampaign}
          />
        )}
        {typeProcedure !== 'backward' && (
          <ThemeProvider theme={customToolbarButtonTheme}>
            <MButton onClick={() => setModal(true)}> {t('title.addParcel')}</MButton>
          </ThemeProvider>
        )}
      </div>
    </Toolbar>
  );
};
